"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LUX_LOYALTY_PROGRAM_CONFIG = void 0;
exports.LUX_LOYALTY_PROGRAM_CONFIG = {
    programDisplayName: 'Société',
    pointsUnit: 'point',
    pointsUnitAbbreviation: 'pt',
    statusCreditsUnit: 'status credit',
};
